import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import userReducer from "./features/userSlice";
// import simulationReducer from "./features/simulationSlice";
import productCriteriaReducer from "./features/productCriteriaSlice";
import consensusReducer from "./features/consensusSlice";
import alreadySelectedProductReducer from "./features/alreadySelectedProductSlice";
import interactionReducer from './features/interactionSlice';
import procurementReducer from './features/procurementSlice';
import forecastReducer from './features/forecastSlice';
import productReducer from './features/productSlice';
import rmPoReducer from './features/rmPoSlice';
import gametizeReducer from './features/gametizeSlice';

// Define persist configuration
const persistConfig = {
  key: "root",
  storage,
  blacklist: ["alreadyselectedproducts",'consensuses','interaction'],
};

// Combine your reducers
const rootReducer = combineReducers({
  user: userReducer,
  productsearchcreteriaetc: productCriteriaReducer,
  consensuses: consensusReducer,
  alreadyselectedproducts: alreadySelectedProductReducer,
  interaction: interactionReducer,
  procurement: procurementReducer,
  forecast: forecastReducer,
  product: productReducer,
  rmPo: rmPoReducer,
  gametize: gametizeReducer

  // Add other reducers here
});

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the store with the persisted reducer
const store = configureStore({
  reducer: persistedReducer,
});

// Create a persistor
const persistor = persistStore(store);

export { store, persistor };
